// PROGRAM: Chat — Chat log, send/receive, localStorage
// Split from retro-utilities.js

(function() {
    'use strict';

    var Chat = {
        chatLog: null,

        init: function() {
            this.chatLog = document.getElementById('chat-log');
            if (this.chatLog) {
                this.loadChat();
            }
        },

        loadChat: function() {
            var history = JSON.parse(localStorage.getItem('retro_chat_history') || '[]');
            if (history.length === 0) {
                history.push({ user: 'Webmaster', text: 'Don\'t forget to sign the guestbook!', time: '10:00' });
                history.push({ user: 'Surfer99', text: 'Cool site!', time: '10:05' });
            }

            this.chatLog.innerHTML = '<div>[System]: Welcome to #Global!</div>';
            var chatLog = this.chatLog;
            history.forEach(function(msg) {
                var div = document.createElement('div');
                div.innerHTML = '<span style="color:#CCC">[' + msg.time + ']</span> <b>&lt;' + msg.user + '&gt;</b> ' + msg.text;
                chatLog.appendChild(div);
            });
            chatLog.scrollTop = chatLog.scrollHeight;

            var savedName = localStorage.getItem('retro_chat_username');
            if (savedName && document.getElementById('chat-username')) {
                document.getElementById('chat-username').value = savedName;
            }
        }
    };

    // Register with PROGRAMS
    window.PROGRAMS.register('Chat', Chat);

    // Global function for inline onsubmit handler
    window.sendChatMessage = function(e) {
        e.preventDefault();
        var input = document.getElementById('chat-input');
        var nameInput = document.getElementById('chat-username');
        var text = input.value.trim();
        var username = nameInput.value.trim() || 'Guest';

        if (!text) return;

        var now = new Date();
        var time = now.getHours() + ':' + String(now.getMinutes()).padStart(2, '0');

        var msgObj = { user: username, text: text, time: time };

        localStorage.setItem('retro_chat_username', username);

        var history = JSON.parse(localStorage.getItem('retro_chat_history') || '[]');
        history.push(msgObj);
        if (history.length > 20) history.shift();
        localStorage.setItem('retro_chat_history', JSON.stringify(history));

        var chatLog = document.getElementById('chat-log');
        var div = document.createElement('div');
        div.innerHTML = '<span style="color:#CCC">[' + time + ']</span> <b>&lt;' + username + '&gt;</b> ' + text;
        chatLog.appendChild(div);
        chatLog.scrollTop = chatLog.scrollHeight;

        input.value = '';
    };

})();
